import { get, post } from './api';
import { LineItemI } from 'declarations/interfaces/lineItems';
import { RepairOrderListI } from 'declarations/interfaces/RepairOrderList';
import { RooftopExistsI } from 'declarations/interfaces/roofTopExists';

export const getRepairOrderExistsApi = async (roofTopId: string, roNumber: string) => {
  const response = await get<RooftopExistsI>(`/repair-order/${roofTopId}/${roNumber}`);

  return response.data;
};

export const getLineItemsApi = async (roofTopId: string, roNumber: string) => {
  const response = await get<LineItemI[]>(`/repair-order/${roofTopId}/${roNumber}/lineItems`);

  return response.data;
};

export const postRepairOderListApi = async (roofTopId: string, RepairOrderNumbers: string[]) => {
  const response = await post<RepairOrderListI>(
    `/integration/pull-repair-orders?RoofTopId=${roofTopId}&RepairOrderNumbers=${RepairOrderNumbers}`
  );
  return response.data;
};
